/* eslint-disable quote-props */
export default {
  'overrides': {
    'MuiFormControl': {
      'root': {
        'maxWidth': '100%',
      },
      'fullWidth': {
        'textAlign': 'left',
        'marginBottom': 20,
      },
    },
    'MuiInput': {
      'root': {
        'fontFamily': 'Heebo, sans-serif',
        'margin': 'auto 20px',
      },
    },
    'MuiFormLabel': {
      'root': {
        'fontFamily': 'Heebo, sans-serif',
        'fontWeight': 400,
        'paddingLeft': '20px',
      },
    },
    'MuiFormHelperText': {
      'root': {
        'fontSize': 14,
        'margin': '8 0 8 0',
      },
    },
    'MuiSnackbarContent': {
      'root': {
        'fontFamily': 'Heebo, sans-serif',
        'backgroundColor': '#3b60ad',
      },
    },
    'MuiTypography': {
      'title': {
        'fontSize': 26,
      },
      'subheading': {
        'fontSize': 22,
      },
    },
    'MuiButton': {
      'root': {
        'fontSize': 16,
      },
    },
    'MuiChip': {
      'root': {
        'color': '#1056ad',
        'backgroundColor': '#f5f8fa',
      },
    },
  },
  'typography': {
    'fontFamily': 'Heebo, sans-serif',
    'fontSize': 14,
    'fontWeightLight': 400,
    'fontWeightRegular': 400,
    'fontWeightMedium': 400,
  },
  'direction': 'ltr',
  'palette': {
    'common': {
      'black': '#000',
      'white': '#fff',
      'transparent': 'rgba(0, 0, 0, 0)',
      'fullBlack': 'rgba(0, 0, 0, 1)',
      'darkBlack': 'rgba(0, 0, 0, 0.87)',
      'lightBlack': 'rgba(0, 0, 0, 0.54)',
      'minBlack': 'rgba(0, 0, 0, 0.26)',
      'faintBlack': 'rgba(0, 0, 0, 0.12)',
      'fullWhite': 'rgba(255, 255, 255, 1)',
      'darkWhite': 'rgba(255, 255, 255, 0.87)',
      'lightWhite': 'rgba(255, 255, 255, 0.54)',
      'green': '#5bd774',
    },
    'type': 'light',
    'primary': {
      'main': '#3b60ad',
      '50': '#e3f2fd',
      '100': '#bbdefb',
      '200': '#90caf9',
      '300': '#64b5f6',
      '400': '#42a5f5',
      '500': '#242121', // updated nav bar color
      '600': '#1e88e5',
      '700': '#1976d2',
      '800': '#1565c0',
      '900': '#0d47a1',
      'A100': '#82b1ff',
      'A200': '#448aff',
      'A400': '#2979ff',
      'A700': '#3e64a9', // update active field hint text color
      'contrastDefaultColor': 'light',
    },
    'secondary': {
      'main': '#09366a',
      '50': '#fce4ec',
      '100': '#f8bbd0',
      '200': '#f48fb1',
      '300': '#f06292',
      '400': '#ec407a',
      '500': '#e91e63',
      '600': '#d81b60',
      '700': '#c2185b',
      '800': '#ad1457',
      '900': '#880e4f',
      'A100': '#ff80ab',
      'A200': '#ff4081',
      'A400': '#f50057',
      'A700': '#c51162',
      'contrastDefaultColor': 'light',
    },
    'error': {
      '50': '#ff1744',
      '100': '#ff1744',
      '200': '#ff1744',
      '300': '#ff1744',
      '400': '#ff1744',
      '500': '#ff1744',
      '600': '#ff1744',
      '700': '#ff1744',
      '800': '#ff1744',
      '900': '#ff1744',
      'A100': '#ff1744',
      'A200': '#ff1744',
      'A400': '#ff1744',
      'A700': '#ff1744',
      'contrastDefaultColor': 'light',
    },
  },
  'breakpoints': {
    'keys': ['xs', 'sm', 'md', 'lg', 'xl'],
    'values': {
      'xs': 0,
      'sm': 600,
      'md': 960,
      'lg': 1280,
      'xl': 1920,
    },
  },
  'spacing': {
    'unit': 8,
  },
};



// WEBPACK FOOTER //
// ./src/styles/muiTheme.js